import { useCallback, useEffect, useState } from 'react'

import {
  Box,
  Pagination,
  Spinner,
  Table,
  Text,
} from '@fairfashion/design-system'
import { useParams } from 'react-router-dom'

import { ICompanyProvidersResponseDTO } from '../../../../sdk/company/company.types'
import { sdk } from '../../../../services/sdk'
import { IPaginatedResponse } from '../../../../types/paginated-response.type'
import { docMask } from '../../../../utilities/masks/brasilianDocuments'

import * as Styles from './provider-list.styles'
export const ProviderList = () => {
  const params = useParams()
  const [page, setPage] = useState(1)
  const [firsttierProviders, setFirsttierProviders] =
    useState<IPaginatedResponse<ICompanyProvidersResponseDTO[]> | null>(null)
  const [firsttierClients, setFirsttierClients] = useState<IPaginatedResponse<
    ICompanyProvidersResponseDTO[]
  > | null>(null)
  const [activeTab, setActiveTab] = useState('Fornece diretamente')
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<IPaginatedResponse<
    ICompanyProvidersResponseDTO[]
  > | null>(null)

  const getFirsttierProvidersByTaxId = useCallback(
    async (page?: number) => {
      try {
        setLoading(true)
        const _response = await sdk.company.getFirsttierProvidersByTaxId(
          params.providerTaxId ?? '',
          page,
        )
        setFirsttierProviders(_response)
      } catch (error) {
      } finally {
        setLoading(false)
      }
    },
    [params],
  )
  const getFirsttierClientsByTaxId = useCallback(
    async (page?: number) => {
      try {
        setLoading(true)
        const _response = await sdk.company.getFirsttierClientsByTaxId(
          params.providerTaxId ?? '',
          page,
        )
        setFirsttierClients(_response)
      } catch (error) {
      } finally {
        setLoading(false)
      }
    },
    [params],
  )
  useEffect(() => {
    getFirsttierProvidersByTaxId()
    getFirsttierClientsByTaxId()
  }, [])

  useEffect(() => {
    if (activeTab === 'Fornece diretamente') {
      setData(firsttierClients)
    }
    if (activeTab === 'Compra diretamente') {
      setData(firsttierProviders)
    }
  }, [activeTab, firsttierProviders, firsttierClients])

  useEffect(() => {
    if (activeTab === 'Fornece diretamente') {
      getFirsttierClientsByTaxId(page)
    }
    if (activeTab === 'Compra diretamente') {
      getFirsttierProvidersByTaxId(page)
    }
  }, [page])

  return (
    <Box padding={3} gap={3} direction="column" flex={1} width="100%">
      <Styles.Tabs>
        <Styles.Tab
          active={activeTab === 'Fornece diretamente'}
          onClick={() => setActiveTab('Fornece diretamente')}
        >
          <Text fontWeight={500} size="small">
            Fornece diretamente
          </Text>
        </Styles.Tab>
        <Styles.Tab
          active={activeTab === 'Compra diretamente'}
          onClick={() => setActiveTab('Compra diretamente')}
        >
          <Text color="grey_3" fontWeight={500} size="small">
            Compra diretamente
          </Text>
        </Styles.Tab>
      </Styles.Tabs>
      <Box width="100%">
        <Table
          headers={[
            { key: 'name', label: 'Nome do fornecedor' },
            { key: 'taxId', label: 'CNPJ' },
          ]}
          data={
            data?.data.map((provider) => ({
              name: provider.name,
              taxId: docMask(`${provider.taxId}`),
            })) ?? []
          }
          footer={
            data?.count ? (
              <Box width="100%" justifyContent="center">
                <Pagination
                  total={Math.ceil(data.count / 5)}
                  current={page >= 1 ? page : 1}
                  onChange={(_page) => setPage(_page)}
                />
              </Box>
            ) : (
              <Box
                width="100%"
                alignItems="center"
                justifyContent="center"
                padding={4}
              >
                {loading ? <Spinner /> : 'Não há dados'}
              </Box>
            )
          }
        />
      </Box>
    </Box>
  )
}
